import { siteName } from "@/constants/config";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PrivacySection = (props: { title: string; description: string; img: string }) => {
  const { title, description, img } = props;
  return (
    <Box>
      <Typography
        variant={"h6"}
        color={""}
        gutterBottom
        sx={{
          fontWeight: "medium",
        }}
      >
        {title}
      </Typography>
      <Typography component={"p"} color={""}>
        {description}
      </Typography>
      <img src={img} className="block max-w-[100%] mt-[10px] mx-auto" alt="" />
    </Box>
  );
};

const Content = () => {
  const data = [
    {
      // title: "1. What information do we collect?",
      description:
        "Citi ThankYou® Rewards provide an excellent opportunity to accumulate rewards through your everyday expenditures. But were you aware that you can exchange your ThankYou® Points for remarkable award flights with airline partners? This comprehensive guide will elucidate the process of transferring your points to these partners and how to utilize them for incredible award flights.",
      // img: "https://img.awardtool-api.com/city_imgs/san_francisco.jpg",
    },
    {
      title: "1. Select Your Airline Partner",
      description:
        'To access the complete roster of Citi airline partners, simply log in to your Citi account and navigate to the ThankYou® Rewards portal. Within the portal, click on the "Transfer Points" tab to view the extensive list of airline partners. Select "ThankYou® Rewards" from the "Rewards & Offers" dropdown.',
      img: "https://img.awardtool-api.com/guides/citi_1_1.png",
    },
    {
      // title: "1. Select Your Airline Partner",
      description:
        ' Within the ThankYou® Rewards portal, select "Points Transfer" from the "More Ways to Redeem" dropdown. This will display a list of Citi ThankYou® transfer partners.',
      img: "https://img.awardtool-api.com/guides/citi_2_2.png",
    },
    {
      title: "2. Connect Your Loyalty Accounts and Initiate the Points Transfer.",
      description:
        "Following your selection of an airline partner, the subsequent step entails linking your loyalty accounts and executing the points transfer. This process entails specifying the quantity of points you intend to transfer and inputting your frequent flyer number for the chosen airline partner.",
      img: "https://img.awardtool-api.com/guides/citi_3.png",
    },
    {
      // title: "2. Connect Your Loyalty Accounts",
      description:
        "Input the number of points you want to transfer and provide your airline loyalty program account details.",
      img: "https://img.awardtool-api.com/guides/citi_4.png",
    },
    {
      title: "3. Secure Your Award Flight",
      description:
        "After successfully transferring your Citi ThankYou® points to your airline partner, the final step involves booking your award flight. To accomplish this, log in to your airline loyalty account and initiate a search for available award flights. For efficiency, you can utilize " + siteName + " to search for award flights across major airline loyalty programs, so you don't need to visit each airline's website individually.",
      // img: "https://img.awardtool-api.com/city_imgs/san_francisco.jpg",
    },
    {
      // title: "8. How can you review, update or delete the data we collect from you?",
      description:
        "Please be mindful that the availability of award flights can fluctuate, so it's advisable to initiate your search well in advance of your intended travel date. It is always prudent to confirm your desired award flight directly on the airline's website before proceeding with the transfer of your Citi ThankYou® Points, as point transfers cannot be reversed.",
      // img: "https://img.awardtool-api.com/city_imgs/san_francisco.jpg",
    },
  ];
  return (
    <Box>
      {data.map((item, i) => (
        <Box key={i} marginBottom={i < data.length - 1 ? 4 : 0}>
          <PrivacySection {...item} />
        </Box>
      ))}
    </Box>
  );
};

export default Content;
